import { Message } from '../../types/chat';
import { generateId } from '../../utils/id';
import { formattingService } from './FormattingService';

export class MessageService {
  createMessage(message: Omit<Message, 'id' | 'timestamp'>): Message {
    const formattedContent = formattingService.formatMessage(message.content);
    
    return {
      id: generateId(),
      timestamp: new Date(),
      ...message,
      content: formattedContent
    };
  }
  
  // Add method to serialize messages for storage
  serializeMessages(messages: Message[]): string {
    return JSON.stringify(messages.map(msg => ({
      ...msg,
      timestamp: msg.timestamp instanceof Date ? msg.timestamp.toISOString() : msg.timestamp
    })));
  }
  
  // Add method to deserialize messages from storage
  deserializeMessages(serialized: string): Message[] {
    try {
      const parsed = JSON.parse(serialized);
      return parsed.map((msg: any) => ({
        ...msg,
        timestamp: msg.timestamp ? new Date(msg.timestamp) : new Date()
      }));
    } catch (error) {
      console.error('Failed to deserialize messages:', error);
      return [];
    }
  }
}

export const messageService = new MessageService();